import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useRef } from "react";
import { useSprings, animated } from "@react-spring/web";
import { useDrag } from "@use-gesture/react";
import { clamp, swap } from "@catchy/app-core";
import { getStopTypeColorClass } from "./StopRow";
import { reorderFavouriteIds } from "@catchy/app-core/src/reorderFavourites";
import StopMarker from "@catchy/assets/svgs/stop-mono-lg.svg";
const CARD_HEIGHT = 72;
const fn = (order, active = false, activeIndex = 0, y = 0, activeBaseIndex = 0) => index => {
  const rowIndex = order.indexOf(index);
  const baseY = Math.max(rowIndex, 0) * CARD_HEIGHT;
  if (active && index === activeIndex) {
    return {
      // Keep drag anchored to where this drag started.
      y: activeBaseIndex * CARD_HEIGHT + y,
      scale: 1.03,
      zIndex: 1,
      shadow: 5,
      immediate: key => key === "y" || key === "zIndex",
      config: {
        tension: 300,
        friction: 20,
        clamp: true
      }
    };
  }
  return {
    y: baseY,
    scale: 1,
    zIndex: 0,
    shadow: 1,
    immediate: false,
    config: {
      tension: 300,
      friction: 20,
      clamp: true
    }
  };
};
const ReorderFavourites = t0 => {
  const $ = _c(29);
  const {
    setFavourites,
    resolveStopType,
    type,
    typeFavourites
  } = t0;
  let t1;
  if ($[0] !== typeFavourites) {
    t1 = typeFavourites.map(_temp);
    $[0] = typeFavourites;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const defaultOrder = t1;
  const order = useRef(defaultOrder);
  const t2 = typeFavourites.length;
  let t3;
  if ($[2] !== defaultOrder) {
    t3 = fn(defaultOrder);
    $[2] = defaultOrder;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [springs, api] = useSprings(t2, t3);
  let t4;
  let t5;
  if ($[4] !== api || $[5] !== defaultOrder) {
    t4 = () => {
      order.current = defaultOrder;
      api.start(index_0 => ({
        ...fn(defaultOrder)(index_0),
        immediate: true
      }));
    };
    t5 = [defaultOrder, api];
    $[4] = api;
    $[5] = defaultOrder;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  if ($[8] !== api || $[9] !== defaultOrder || $[10] !== setFavourites || $[11] !== typeFavourites) {
    t6 = t7 => {
      const {
        args: t8,
        active,
        movement: t9
      } = t7;
      const [originalIndex] = t8;
      const [, y] = t9;
      const activeBaseIndex = order.current.indexOf(originalIndex);
      const curRow = clamp(Math.round((activeBaseIndex * CARD_HEIGHT + y) / CARD_HEIGHT), 0, typeFavourites.length - 1);
      const newOrder = swap(order.current, activeBaseIndex, curRow);
      api.start(fn(newOrder, active, originalIndex, y, activeBaseIndex));
      if (!active) {
        order.current = newOrder;
        if (!newOrder.every((value, index_2) => value === defaultOrder[index_2])) {
          const ids = newOrder.map(index_1 => typeFavourites[index_1].stop_id);
          setFavourites(current => reorderFavouriteIds(current, ids));
        }
      }
    };
    $[8] = api;
    $[9] = defaultOrder;
    $[10] = setFavourites;
    $[11] = typeFavourites;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const bind = useDrag(t6);
  const t7 = typeFavourites.length * CARD_HEIGHT;
  let t8;
  if ($[13] !== t7) {
    t8 = {
      height: t7
    };
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== bind || $[16] !== resolveStopType || $[17] !== springs || $[18] !== type || $[19] !== typeFavourites) {
    let t10;
    if ($[21] !== bind || $[22] !== resolveStopType || $[23] !== type || $[24] !== typeFavourites) {
      t10 = (t11, i) => {
        const {
          zIndex,
          shadow,
          y: y_0,
          scale
        } = t11;
        const stop = typeFavourites[i];
        const key = stop?.stop_id ?? i;
        const stopType = resolveStopType ? resolveStopType({
          stop_id: stop?.stop_id,
          stop_type: stop?.stop_type,
          type
        }) : stop?.stop_type || type;
        return <animated.div {...bind(i)} key={key} style={{
          zIndex,
          boxShadow: shadow.to(_temp2),
          y: y_0,
          scale
        }} className="pointer-events-auto absolute flex w-full cursor-grab touch-none select-none flex-row items-center rounded-lg bg-white p-2 active:cursor-grabbing dark:bg-zinc-800"><div key="marker" className="grid h-11 w-11 shrink-0 place-content-center pr-0.5"><StopMarker className={`${getStopTypeColorClass(stopType)} ml-[16px] mr-[16px] mt-0.5 h-[1.125rem] w-3 flex-shrink-0`} /></div><div key="label"><span className="line-clamp-1">{stop?.stop_name}</span></div></animated.div>;
      };
      $[21] = bind;
      $[22] = resolveStopType;
      $[23] = type;
      $[24] = typeFavourites;
      $[25] = t10;
    } else {
      t10 = $[25];
    }
    t9 = springs.map(t10);
    $[15] = bind;
    $[16] = resolveStopType;
    $[17] = springs;
    $[18] = type;
    $[19] = typeFavourites;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[26] !== t8 || $[27] !== t9) {
    t10 = <div style={t8} className="relative">{t9}</div>;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};
export default ReorderFavourites;
function _temp(_, index) {
  return index;
}
function _temp2(s) {
  return `rgb(229,231,235) 0px 0px 0px 1px, rgba(0,0,0,0.1) 0px ${s * 2}px ${s * 3}px -${s * 0.6}px, rgba(0, 0, 0, 0.1) 0px ${s * 0.8}px ${s * 1.2}px -${s * 0.8}px`;
}